var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32, _path34, _g33, _path35, _g34, _path36, _g35, _path37, _g36, _path38, _g37, _path39, _g38, _path40, _g39, _path41, _g40, _path42, _g41, _path43, _g42, _path44, _g43, _path45, _g44, _path46, _g45, _path47, _g46, _path48, _g47, _path49, _g48, _path50, _g49, _path51, _g50, _path52, _g51, _path53, _g52, _path54, _g53, _path55, _g54, _path56, _g55, _path57, _g56, _path58, _g57, _path59, _g58, _path60, _g59, _path61, _g60, _path62, _g61, _path63, _g62, _path64, _g63, _path65, _g64, _path66, _g65, _path67, _g66, _path68, _g67, _path69, _g68, _path70, _g69, _path71, _g70, _path72, _g71, _path73, _g72, _path74, _g73, _path75, _g74, _path76, _g75, _path77, _g76, _path78, _g77, _path79, _g78, _path80, _g79, _path81, _g80, _path82, _g81, _path83, _g82, _path84, _g83, _path85, _g84, _path86, _g85, _path87, _g86, _path88, _g87, _path89, _g88, _path90, _g89, _path91, _g90, _path92, _g91, _path93, _g92, _path94, _g93, _path95, _g94, _path96, _g95, _path97, _g96, _path98, _g97, _path99, _g98, _path100, _g99, _path101, _g100, _path102, _g101, _path103, _g102, _path104, _g103, _path105, _g104, _path106, _g105, _path107, _g106, _path108, _g107, _path109, _g108, _path110, _g109, _path111, _g110, _path112, _g111, _path113, _g112, _path114, _g113, _path115, _g114, _path116, _g115, _path117, _g116, _path118, _g117, _path119, _g118, _path120, _g119, _path121, _g120, _path122, _g121, _path123, _g122, _path124, _g123;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArgentina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 7.21191H0.753906V13.7379H34.3149V7.21191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V7.21054H34.3149V0.685547Z",
    fill: "#80A7D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 13.7373H0.753906V20.2613H34.3149V13.7373Z",
    fill: "#80A7D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_85191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4004 10.4717L17.5024 13.1437C17.5024 13.1437 17.5023 13.1937 17.5353 13.1937C17.5663 13.1937 17.5663 13.1437 17.5663 13.1437L17.6684 10.4717H17.4004Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5345 13.2007C17.5015 13.2007 17.4936 13.1617 17.4936 13.1427L17.3916 10.4737L17.4095 10.4707L17.5076 13.1427C17.5076 13.1427 17.5075 13.1837 17.5345 13.1837C17.5575 13.1837 17.5576 13.1427 17.5576 13.1427L17.6595 10.4707L17.5776 13.1427C17.5776 13.1617 17.5655 13.2007 17.5345 13.2007Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 10.4717L17.5347 12.3067L17.5997 10.4717H17.4688Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2831 11.3359C17.1311 11.6719 17.2581 11.9459 17.1091 12.2389C16.9531 12.5319 17.0481 12.7729 17.0411 12.9089C17.0291 13.0439 16.9221 13.0819 16.9471 13.1129C16.9761 13.1429 17.0911 13.0829 17.1351 12.9019C17.1801 12.7229 17.0741 12.6209 17.2541 12.2609C17.4401 11.9009 17.2951 11.7389 17.4811 11.4169L17.2831 11.3359Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9772 13.128L16.9402 13.118C16.9262 13.098 16.9402 13.079 16.9612 13.057C16.9862 13.028 17.0272 12.983 17.0292 12.907C17.0332 12.871 17.0292 12.828 17.0232 12.777C17.0072 12.64 16.9862 12.453 17.1012 12.236C17.1752 12.09 17.1792 11.951 17.1852 11.803C17.1892 11.656 17.1972 11.502 17.2772 11.332L17.2912 11.338C17.2152 11.505 17.2072 11.657 17.2032 11.804C17.1972 11.951 17.1892 12.095 17.1172 12.242C17.0042 12.454 17.0272 12.642 17.0412 12.777C17.0452 12.828 17.0492 12.871 17.0492 12.909C17.0412 12.99 17.0002 13.036 16.9732 13.068C16.9532 13.09 16.9482 13.098 16.9532 13.107C17.0192 13.098 17.0962 13.034 17.1292 12.9C17.1432 12.841 17.1432 12.79 17.1392 12.734C17.1312 12.622 17.1292 12.497 17.2502 12.257C17.3422 12.079 17.3522 11.95 17.3592 11.826C17.3672 11.697 17.3792 11.575 17.4722 11.412C17.3922 11.581 17.3842 11.7 17.3742 11.826C17.3662 11.951 17.3552 12.085 17.2652 12.264C17.1462 12.5 17.1502 12.624 17.1522 12.732C17.1562 12.791 17.1562 12.842 17.1422 12.906C17.1092 13.036 17.0372 13.113 16.9822 13.127L16.9772 13.128Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3279 11.4209C17.2069 11.7559 17.3319 11.9769 17.1719 12.2619C17.3499 12.0579 17.2329 11.7959 17.3849 11.4489L17.3279 11.4209Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6684 10.4719L17.5663 7.80486C17.5663 7.80486 17.5663 7.75586 17.5353 7.75586C17.5023 7.75586 17.5024 7.80486 17.5024 7.80486L17.4004 10.4719H17.6684Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6602 10.4742L17.5582 7.80515C17.5582 7.80515 17.5582 7.76215 17.5352 7.76215C17.5082 7.76215 17.5082 7.80414 17.5082 7.80414L17.4102 10.4742L17.4942 7.80414C17.4942 7.78314 17.5022 7.74414 17.5352 7.74414C17.5662 7.74414 17.5782 7.78214 17.5782 7.80414L17.6802 10.4711L17.6602 10.4742Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5997 10.4716L17.5347 8.64258L17.4688 10.4716H17.5997Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7868 9.60938C17.9388 9.27538 17.8078 9.00137 17.9608 8.70737C18.1168 8.41337 18.0198 8.17238 18.0268 8.03838C18.0388 7.90438 18.1498 7.86639 18.1208 7.83439C18.0958 7.80439 17.9798 7.86639 17.9328 8.04339C17.8878 8.22239 17.9968 8.32538 17.8118 8.68638C17.6278 9.04438 17.7768 9.20738 17.5908 9.52938L17.7868 9.60938Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7946 9.61333L17.7806 9.60733C17.8546 9.44133 17.8586 9.29033 17.8666 9.14333C17.8706 8.99333 17.8787 8.85132 17.9547 8.70332C18.0617 8.49132 18.0446 8.30833 18.0266 8.17133C18.0266 8.11933 18.0186 8.07333 18.0226 8.03833C18.0266 7.95533 18.0696 7.90933 18.0946 7.87833C18.1156 7.85533 18.1197 7.84633 18.1157 7.84033C18.0507 7.84533 17.9747 7.91033 17.9417 8.04533C17.9237 8.10733 17.9276 8.15833 17.9316 8.21233C17.9356 8.32433 17.9416 8.44833 17.8186 8.68933C17.7286 8.86733 17.7167 8.99733 17.7097 9.12233C17.6997 9.25033 17.6926 9.37033 17.5986 9.53233C17.6746 9.36433 17.6846 9.24532 17.6926 9.11932C17.7026 8.99332 17.7096 8.86434 17.8036 8.68134C17.9246 8.44834 17.9207 8.32333 17.9127 8.21233C17.9127 8.15833 17.9086 8.10433 17.9246 8.04333C17.9596 7.89833 18.0396 7.83033 18.0866 7.82033L18.0906 7.81934L18.1276 7.83032C18.1456 7.84832 18.1276 7.86733 18.1076 7.88933C18.0846 7.91833 18.0397 7.96333 18.0377 8.03833C18.0337 8.07533 18.0376 8.11933 18.0436 8.16933C18.0576 8.30933 18.0807 8.49533 17.9677 8.71133C17.8917 8.85633 17.8877 8.99633 17.8817 9.14433C17.8787 9.29133 17.8706 9.44533 17.7946 9.61333Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7437 9.52454C17.8667 9.19154 17.7357 8.96855 17.8997 8.68555C17.7217 8.88855 17.8346 9.15054 17.6826 9.49554L17.7437 9.52454Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5344 10.3398L14.8644 10.4388C14.8644 10.4388 14.8135 10.4388 14.8135 10.4718C14.8135 10.5078 14.8644 10.5078 14.8644 10.5078L17.5344 10.6078V10.3398Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5366 10.6L14.8646 10.515C14.8476 10.515 14.8076 10.507 14.8076 10.472C14.8076 10.442 14.8466 10.433 14.8646 10.433L17.5346 10.332L17.5366 10.349L14.8646 10.449C14.8646 10.449 14.8217 10.449 14.8217 10.472C14.8217 10.499 14.8646 10.499 14.8646 10.499L17.5366 10.6Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5351 10.4053L15.7031 10.4713L17.5351 10.5393V10.4053Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6715 10.2217C16.3375 10.0677 16.0625 10.1987 15.7715 10.0457C15.4745 9.8937 15.2345 9.98869 15.0975 9.97969C14.9645 9.96769 14.9275 9.85769 14.8945 9.88669C14.8655 9.91269 14.9275 10.0287 15.1055 10.0727C15.2855 10.1187 15.3865 10.0117 15.7465 10.1947C16.1055 10.3817 16.2695 10.2337 16.5925 10.4187L16.6715 10.2217Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5959 10.4099C16.4279 10.3349 16.3049 10.3249 16.1819 10.3139C16.0549 10.3049 15.9239 10.2949 15.7429 10.2029C15.5089 10.0829 15.3859 10.0869 15.2759 10.0919C15.2169 10.0959 15.1669 10.0969 15.1059 10.0809C14.9709 10.0479 14.8949 9.97392 14.8829 9.92092L14.8809 9.91491L14.8909 9.87992C14.9139 9.86092 14.9319 9.87991 14.9539 9.89991C14.9789 9.92591 15.0259 9.96591 15.1019 9.97091C15.1329 9.97391 15.1819 9.96792 15.2289 9.96192C15.3679 9.94792 15.5589 9.92591 15.7759 10.0379C15.9219 10.1139 16.0589 10.1209 16.2079 10.1249C16.3569 10.1289 16.5049 10.1359 16.6769 10.2129L16.6729 10.2299C16.5009 10.1529 16.3529 10.1479 16.2079 10.1419C16.0559 10.1359 15.9149 10.1329 15.7669 10.0539C15.5559 9.94391 15.3689 9.96391 15.2339 9.97991C15.1829 9.98591 15.1379 9.98991 15.0989 9.98691C15.0189 9.98091 14.9719 9.93992 14.9429 9.91192C14.9219 9.89392 14.9119 9.88791 14.9039 9.89391C14.9119 9.95891 14.9719 10.0319 15.1109 10.0659C15.1679 10.0799 15.2179 10.0789 15.2769 10.0769C15.3859 10.0719 15.5129 10.0659 15.7519 10.1889C15.9299 10.2809 16.0609 10.2899 16.1839 10.2989C16.3089 10.3089 16.4319 10.3169 16.5959 10.4099Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5881 10.2624C16.2541 10.1454 16.0331 10.2704 15.7461 10.1104C15.9491 10.2894 16.2151 10.1714 16.5591 10.3264L16.5881 10.2624Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 10.6069L20.2052 10.5069C20.2052 10.5069 20.2542 10.5069 20.2542 10.4709C20.2542 10.4379 20.2052 10.4379 20.2052 10.4379L17.5352 10.3389V10.6069Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5372 10.6167L17.5352 10.5986L20.2052 10.4977C20.2052 10.4977 20.2462 10.4976 20.2462 10.4706C20.2462 10.4476 20.2052 10.4476 20.2052 10.4476L17.5352 10.3477L20.2052 10.4317C20.2232 10.4317 20.2602 10.4406 20.2602 10.4706C20.2602 10.5056 20.2232 10.5137 20.2052 10.5137L17.5372 10.6167Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 10.5393L19.3672 10.4713L17.5352 10.4053V10.5393Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3955 10.7253C18.7335 10.8783 19.0085 10.7463 19.3015 10.9013C19.5925 11.0553 19.8345 10.9583 19.9695 10.9693C20.1025 10.9793 20.1395 11.0883 20.1725 11.0603C20.2035 11.0333 20.1395 10.9173 19.9615 10.8723C19.7835 10.8283 19.6785 10.9353 19.3225 10.7513C18.9615 10.5663 18.7975 10.7143 18.4785 10.5283L18.3955 10.7253Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1616 11.0732C20.1476 11.0732 20.1326 11.0612 20.1186 11.0482C20.0896 11.0222 20.0466 10.9832 19.9706 10.9782C19.9336 10.9742 19.8906 10.9792 19.8396 10.9862C19.6986 11.0012 19.5136 11.0202 19.2986 10.9082C19.1506 10.8322 19.0135 10.8272 18.8625 10.8212C18.7145 10.8172 18.5616 10.8102 18.3916 10.7322L18.3996 10.7172C18.5656 10.7932 18.7135 10.7992 18.8625 10.8052C19.0125 10.8112 19.1536 10.8172 19.3056 10.8932C19.5166 11.0042 19.7006 10.9832 19.8346 10.9682C19.8896 10.9632 19.9325 10.9572 19.9695 10.9612C20.0495 10.9672 20.0966 11.0072 20.1276 11.0342C20.1526 11.0552 20.1606 11.0572 20.1646 11.0542C20.1606 10.9902 20.0965 10.9152 19.9615 10.8822C19.9005 10.8662 19.8506 10.8672 19.7956 10.8692C19.6826 10.8762 19.5595 10.8822 19.3185 10.7582C19.1385 10.6672 19.0115 10.6572 18.8885 10.6492C18.7595 10.6382 18.6385 10.6292 18.4745 10.5352C18.6405 10.6132 18.7595 10.6212 18.8885 10.6322C19.0115 10.6422 19.1426 10.6532 19.3266 10.7452C19.5586 10.8652 19.6816 10.8592 19.7956 10.8532C19.8506 10.8512 19.9026 10.8482 19.9656 10.8652C20.1066 10.9002 20.1746 10.9812 20.1866 11.0262V11.0312L20.1746 11.0662C20.1736 11.0722 20.1696 11.0732 20.1616 11.0732Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 10.6821C18.8165 10.8031 19.0395 10.6781 19.3245 10.8361C19.1215 10.6591 18.8575 10.7761 18.5115 10.6211L18.4805 10.6821Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4397 10.3789L15.6226 12.3379C15.6226 12.3379 15.5896 12.3729 15.6126 12.3979C15.6346 12.4189 15.6696 12.3839 15.6696 12.3839L17.6287 10.5679L17.4397 10.3789Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6304 12.4131C15.5834 12.3791 15.6054 12.344 15.6164 12.33L17.4324 10.373L17.4464 10.384L15.6304 12.3421C15.6264 12.3421 15.6014 12.3721 15.6164 12.3891C15.6344 12.4101 15.6675 12.3771 15.6675 12.3771L17.6244 10.563L15.6774 12.3901C15.6774 12.3901 15.6554 12.4121 15.6304 12.4131Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 10.4258L16.2402 11.7688L17.5842 10.5198L17.4863 10.4258Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7459 10.9043C16.3979 11.0323 16.297 11.3213 15.986 11.4193C15.668 11.5203 15.5659 11.7563 15.4639 11.8453C15.3619 11.9333 15.2569 11.8813 15.2529 11.9243C15.2529 11.9643 15.3759 12.0013 15.5359 11.9063C15.6899 11.8133 15.6859 11.6633 16.0709 11.5403C16.4599 11.4163 16.467 11.1983 16.827 11.1043L16.7459 10.9043Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3441 11.9754C15.3131 11.9754 15.2851 11.9684 15.2681 11.9584L15.2471 11.9244C15.2471 11.8974 15.2721 11.8964 15.3021 11.8954C15.3411 11.8914 15.4001 11.8874 15.4581 11.8384C15.4871 11.8164 15.513 11.7814 15.54 11.7424C15.628 11.6344 15.747 11.4844 15.983 11.4104C16.139 11.3614 16.2431 11.2674 16.3481 11.1674C16.4571 11.0654 16.5711 10.9624 16.7441 10.8984L16.7501 10.9134C16.5801 10.9764 16.4691 11.0794 16.3591 11.1794C16.2501 11.2814 16.1481 11.3774 15.9861 11.4264C15.7571 11.4984 15.6361 11.6474 15.5541 11.7524C15.5211 11.7934 15.4951 11.8264 15.4681 11.8504C15.4051 11.9044 15.343 11.9094 15.3 11.9134C15.275 11.9134 15.261 11.9144 15.261 11.9254C15.316 11.9664 15.4131 11.9714 15.5291 11.9024C15.5841 11.8704 15.6171 11.8324 15.6561 11.7914C15.7281 11.7114 15.8161 11.6164 16.0721 11.5344C16.2611 11.4724 16.3591 11.3884 16.4531 11.3084C16.5511 11.2234 16.6421 11.1444 16.8281 11.0954C16.6521 11.1594 16.5621 11.2364 16.4651 11.3204C16.3711 11.4024 16.274 11.4874 16.076 11.5494C15.826 11.6304 15.7421 11.7214 15.6681 11.8024C15.6311 11.8434 15.5941 11.8824 15.5391 11.9144C15.4651 11.9584 15.3981 11.9754 15.3441 11.9754Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7147 10.9951C16.3947 11.1461 16.3256 11.3911 16.0156 11.4801C16.2836 11.4601 16.3847 11.1931 16.7407 11.0591L16.7147 10.9951Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6285 10.567L19.4445 8.61097C19.4445 8.61097 19.4794 8.57498 19.4584 8.54998C19.4334 8.52698 19.3975 8.56098 19.3975 8.56098L17.4385 10.378L17.6285 10.567Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6354 10.573L17.6254 10.565L19.4413 8.605C19.4413 8.605 19.4664 8.575 19.4514 8.556C19.4334 8.54 19.4044 8.567 19.4044 8.567L17.4434 10.384L19.3943 8.55499C19.4043 8.54199 19.4413 8.52201 19.4623 8.54401C19.4833 8.56801 19.4624 8.601 19.4504 8.614L17.6354 10.573Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5843 10.5197L18.8323 9.17871L17.4863 10.4257L17.5843 10.5197Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3241 10.0417C18.6681 9.91268 18.7691 9.62566 19.0861 9.52666C19.4011 9.42766 19.5061 9.18867 19.6081 9.10067C19.7101 9.01367 19.8151 9.06566 19.8151 9.02266C19.8191 8.98166 19.6961 8.94366 19.5361 9.03966C19.3761 9.13466 19.3801 9.28167 18.9971 9.40667C18.6121 9.53067 18.6011 9.74966 18.2451 9.84566L18.3241 10.0417Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3241 10.0492L18.3201 10.0342C18.4921 9.97016 18.5991 9.86616 18.7091 9.76716C18.8161 9.66416 18.9221 9.56815 19.0861 9.51815C19.3111 9.44815 19.4301 9.30216 19.5141 9.19416C19.5471 9.15316 19.5751 9.11915 19.6041 9.09315C19.6631 9.04115 19.7271 9.03716 19.7681 9.03416C19.7971 9.03216 19.8071 9.03016 19.8071 9.02116C19.7561 8.98016 19.6591 8.97415 19.5401 9.04415C19.4891 9.07415 19.4521 9.11416 19.4171 9.15316C19.3411 9.23616 19.2531 9.32815 18.9991 9.41415C18.8081 9.47415 18.7101 9.55616 18.6141 9.63816C18.5161 9.72216 18.4261 9.80216 18.2451 9.85116C18.4191 9.78816 18.5111 9.70916 18.6041 9.62516C18.6981 9.54316 18.7991 9.46015 18.9971 9.39815C19.2471 9.31515 19.3291 9.22316 19.4011 9.14416C19.4421 9.10216 19.4771 9.06416 19.5321 9.03016C19.6491 8.96116 19.7531 8.96016 19.8011 8.98716L19.8241 9.02315C19.8201 9.04615 19.7972 9.04815 19.7672 9.05115C19.7302 9.05215 19.6691 9.05616 19.6151 9.10516C19.5861 9.12916 19.5601 9.16315 19.5271 9.20315C19.4411 9.31315 19.3201 9.46216 19.0891 9.53216C18.9291 9.58116 18.8271 9.67816 18.7181 9.77816C18.6111 9.88016 18.4981 9.98416 18.3241 10.0492Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3541 9.95078C18.6761 9.79878 18.7451 9.55277 19.0571 9.46777C18.7901 9.48577 18.684 9.75276 18.332 9.88676L18.3541 9.95078Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6287 10.379L15.6696 8.56196C15.6696 8.56196 15.6346 8.52795 15.6126 8.55095C15.5896 8.57495 15.6226 8.61196 15.6226 8.61196L17.4397 10.568L17.6287 10.379Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4474 10.5647L15.6174 8.61468C15.6054 8.60068 15.5844 8.56868 15.6094 8.54568C15.6314 8.52268 15.6644 8.54267 15.6774 8.55567L17.6343 10.3727L17.6244 10.3847L15.6673 8.56867C15.6673 8.56867 15.6344 8.54168 15.6164 8.55668C15.6004 8.57568 15.6264 8.60467 15.6304 8.60467L17.4474 10.5647Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5842 10.4257L16.2402 9.17871L17.4863 10.5197L17.5842 10.4257Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1014 9.68546C16.9764 9.33846 16.6895 9.23846 16.5875 8.92246C16.4895 8.60446 16.2534 8.50346 16.1634 8.40046C16.0754 8.29846 16.1264 8.19446 16.0834 8.19146C16.0424 8.18846 16.0075 8.31546 16.0975 8.47246C16.1955 8.62946 16.3434 8.62645 16.4684 9.01145C16.5914 9.39545 16.8084 9.40746 16.9064 9.76646L17.1014 9.68546Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9143 9.76462C16.8483 9.58962 16.7733 9.49962 16.6893 9.40262C16.6053 9.30762 16.5233 9.20763 16.4603 9.01562C16.3763 8.76262 16.2863 8.67962 16.2063 8.60562C16.1633 8.56862 16.1223 8.53262 16.0913 8.47762C16.0193 8.35162 16.0253 8.24761 16.0503 8.20761L16.0873 8.18262C16.1083 8.18562 16.1123 8.21062 16.1123 8.24062C16.1163 8.27862 16.1203 8.33861 16.1673 8.39561C16.1903 8.42261 16.2273 8.45161 16.2683 8.48361C16.3763 8.56961 16.5223 8.68662 16.5943 8.92162C16.6453 9.07762 16.7383 9.17962 16.8403 9.28862C16.9383 9.39562 17.0433 9.50962 17.1113 9.68362L17.0933 9.68962C17.0303 9.51962 16.9273 9.40662 16.8253 9.29962C16.7233 9.19062 16.6283 9.08562 16.5773 8.92462C16.5053 8.69862 16.3603 8.58261 16.2553 8.49661C16.2163 8.46361 16.1793 8.43562 16.1533 8.40762C16.1023 8.34462 16.0983 8.28262 16.0943 8.24162C16.0903 8.21362 16.0903 8.20162 16.0803 8.20062C16.0393 8.25162 16.0333 8.34861 16.1023 8.47061C16.1353 8.52361 16.1743 8.55662 16.2153 8.59462C16.2933 8.66962 16.3893 8.75562 16.4733 9.01062C16.5303 9.19962 16.6173 9.29862 16.6963 9.39462C16.7833 9.48862 16.8633 9.58062 16.9143 9.76462Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0154 9.65414C16.8594 9.33314 16.6134 9.26515 16.5254 8.95215C16.5454 9.22015 16.8164 9.32415 16.9474 9.67815L17.0154 9.65414Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4395 10.5669L19.3984 12.3829C19.3984 12.3829 19.4335 12.4179 19.4595 12.3969C19.4815 12.3719 19.4454 12.3369 19.4454 12.3369L17.6295 10.3779L17.4395 10.5669Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4376 12.4028C19.4086 12.4028 19.3946 12.3888 19.3946 12.3888L17.4336 10.5748L17.4435 10.5628L19.4046 12.3768C19.4046 12.3768 19.4336 12.4088 19.4516 12.3888C19.4676 12.3718 19.4416 12.3418 19.4416 12.3418L17.6255 10.3838L19.4516 12.3298C19.4676 12.3468 19.4846 12.3788 19.4636 12.3998C19.4546 12.4028 19.4486 12.4028 19.4376 12.4028Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 10.5198L18.8323 11.7688L17.5843 10.4258L17.4863 10.5198Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9648 11.2636C18.0958 11.6086 18.3828 11.7076 18.4808 12.0256C18.5788 12.3406 18.8168 12.4446 18.9048 12.5456C18.9968 12.6496 18.9418 12.7536 18.9848 12.7566C19.0238 12.7576 19.0648 12.6346 18.9688 12.4756C18.8748 12.3176 18.7268 12.3196 18.6038 11.9376C18.4768 11.5506 18.2578 11.5396 18.1648 11.1826L17.9648 11.2636Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9841 12.7626C18.9591 12.7626 18.9591 12.7356 18.9551 12.7056C18.9511 12.6676 18.9471 12.6086 18.9001 12.5506C18.8751 12.5246 18.8431 12.4956 18.8021 12.4656C18.6931 12.3796 18.544 12.2616 18.472 12.0266C18.425 11.8706 18.3271 11.7676 18.2261 11.6586C18.1281 11.5506 18.0231 11.4386 17.9561 11.2656L17.972 11.2586C18.038 11.4296 18.1381 11.5396 18.2391 11.6476C18.3411 11.7586 18.4401 11.8616 18.4871 12.0226C18.5591 12.2516 18.708 12.3676 18.811 12.4546C18.852 12.4856 18.8891 12.5126 18.9111 12.5426C18.9641 12.6026 18.9681 12.6656 18.9681 12.7056C18.9721 12.7376 18.9761 12.7466 18.9841 12.7466C19.0271 12.6946 19.0351 12.5986 18.9631 12.4796C18.9301 12.4266 18.8951 12.3906 18.8541 12.3526C18.7701 12.2786 18.6801 12.1926 18.5961 11.9386C18.5361 11.7476 18.4511 11.6506 18.3671 11.5536C18.2851 11.4566 18.2051 11.3656 18.1581 11.1836C18.2191 11.3576 18.2951 11.4486 18.3831 11.5446C18.4611 11.6396 18.5491 11.7376 18.6121 11.9336C18.6921 12.1836 18.7861 12.2676 18.8641 12.3406C18.9051 12.3796 18.9461 12.4146 18.9771 12.4696C19.0471 12.5886 19.0491 12.6926 19.0201 12.7406L18.9841 12.7626Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0566 11.2915C18.2066 11.6125 18.4547 11.6795 18.5427 11.9935C18.5227 11.7235 18.2556 11.6215 18.1206 11.2695L18.0566 11.2915Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4099 10.4219L16.4819 12.9279C16.4819 12.9279 16.4639 12.9739 16.4939 12.9859C16.5249 12.9999 16.5449 12.9539 16.5449 12.9539L17.6559 10.5259L17.4099 10.4219Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5154 12.9939C16.4604 12.9799 16.4684 12.9429 16.4764 12.9239L17.4024 10.4189L17.4184 10.4259L16.4904 12.9299C16.4904 12.9299 16.4764 12.9699 16.4964 12.9789L16.5374 12.9489L17.6504 10.5219L16.5504 12.9579C16.5504 12.9579 16.5404 12.9839 16.5154 12.9939Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.477 10.4473L16.834 12.1663L17.596 10.4983L17.477 10.4473Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9727 11.1748C16.7027 11.4258 16.7187 11.7288 16.4647 11.9418C16.2107 12.1548 16.2067 12.4148 16.1447 12.5348C16.0847 12.6548 15.9686 12.6478 15.9826 12.6868C15.9966 12.7258 16.1276 12.7118 16.2366 12.5648C16.3436 12.4178 16.2876 12.2798 16.5956 12.0178C16.9026 11.7568 16.8276 11.5518 17.1206 11.3258L16.9727 11.1748Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0249 12.7129C16.0189 12.7129 16.0149 12.7129 16.0109 12.7119L15.9739 12.6899C15.9639 12.6669 15.9899 12.6549 16.0149 12.6429C16.0499 12.6229 16.1049 12.5979 16.1379 12.5319C16.1559 12.4979 16.1669 12.4549 16.1809 12.4059C16.2179 12.2739 16.2729 12.0929 16.4599 11.9369C16.5829 11.8319 16.6419 11.7029 16.7059 11.5689C16.7649 11.4339 16.8289 11.2959 16.9639 11.1689L16.9759 11.1819C16.8449 11.3059 16.7789 11.4439 16.7179 11.5749C16.6549 11.7139 16.5969 11.8419 16.4679 11.9479C16.2859 12.1019 16.2359 12.2799 16.1949 12.4119C16.1809 12.4639 16.1679 12.5069 16.1519 12.5399C16.1169 12.6119 16.0579 12.6409 16.0209 12.6569C15.9959 12.6709 15.9859 12.6769 15.9899 12.6849C16.0549 12.7049 16.1439 12.6719 16.2279 12.5609C16.2649 12.5109 16.2829 12.4629 16.2999 12.4119C16.3409 12.3069 16.3838 12.1889 16.5868 12.0139C16.7388 11.8849 16.7959 11.7699 16.8549 11.6579C16.9139 11.5439 16.9679 11.4349 17.1169 11.3209C16.9799 11.4449 16.9288 11.5519 16.8708 11.6639C16.8118 11.7779 16.7539 11.8939 16.5979 12.0269C16.3989 12.1979 16.3559 12.3149 16.3169 12.4169C16.2969 12.4699 16.2799 12.5209 16.2429 12.5709C16.1679 12.6699 16.0759 12.7129 16.0249 12.7129Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9807 11.2695C16.7407 11.5315 16.7736 11.7845 16.5156 11.9855C16.7576 11.8665 16.7496 11.5775 17.0236 11.3205L16.9807 11.2695Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 10.5246L18.5892 8.01963C18.5892 8.01963 18.6072 7.97464 18.5732 7.96164C18.5442 7.94764 18.5262 7.99363 18.5262 7.99363L17.4092 10.4206L17.6562 10.5246Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.668 10.5251L17.65 10.5201L18.5779 8.01514C18.5779 8.01514 18.5959 7.97812 18.5739 7.96812L18.5349 7.99612L17.418 10.4241L18.5159 7.99013C18.5159 7.99013 18.5319 7.96212 18.5529 7.95312L18.5999 7.97214C18.6079 7.99314 18.5959 8.02013 18.5959 8.02213L17.668 10.5251Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5956 10.4983L18.2375 8.78027L17.4766 10.4473L17.5956 10.4983Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1002 9.77252C18.3682 9.52052 18.3542 9.21652 18.6082 9.00552C18.8622 8.79352 18.8642 8.53253 18.9222 8.41153C18.9882 8.29153 19.1043 8.30053 19.0903 8.26053C19.0713 8.22053 18.9462 8.23452 18.8362 8.38052C18.7232 8.52852 18.7852 8.66552 18.4772 8.92752C18.1682 9.18952 18.2412 9.39553 17.9482 9.62053L18.1002 9.77252Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1041 9.77975L18.092 9.76776C18.227 9.64276 18.289 9.50575 18.35 9.37175C18.411 9.23475 18.469 9.10676 18.6 8.99976C18.786 8.84776 18.8361 8.66676 18.8751 8.53676C18.8911 8.48676 18.9001 8.44275 18.9181 8.41075C18.9551 8.33675 19.0141 8.30876 19.0471 8.29176C19.0701 8.27776 19.086 8.27176 19.082 8.26376C19.014 8.24476 18.9221 8.27776 18.8441 8.38776C18.8031 8.43676 18.7891 8.48776 18.7661 8.53676C18.7311 8.64376 18.6841 8.76276 18.4811 8.93576C18.3321 9.06376 18.2701 9.17776 18.2151 9.29076C18.1581 9.40476 18.1041 9.51476 17.9551 9.62776C18.0881 9.50276 18.143 9.39576 18.201 9.28276C18.256 9.16976 18.3161 9.05275 18.4691 8.92375C18.6721 8.75275 18.7111 8.63576 18.7521 8.53276C18.7731 8.47776 18.7931 8.42776 18.8281 8.37776C18.9081 8.26976 19.0021 8.22476 19.0601 8.23476L19.095 8.25876C19.103 8.28076 19.0811 8.29276 19.0561 8.30576C19.0191 8.32276 18.964 8.34776 18.933 8.41576C18.914 8.44776 18.9041 8.48975 18.8901 8.53975C18.8531 8.67375 18.7981 8.85475 18.6111 9.01175C18.4841 9.11675 18.429 9.24376 18.363 9.37776C18.303 9.51476 18.2401 9.65275 18.1041 9.77975Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0919 9.67891C18.3319 9.41691 18.2989 9.16291 18.5569 8.96191C18.3129 9.08191 18.3209 9.36791 18.0449 9.62791L18.0919 9.67891Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5839 10.3504L15.0799 9.42139C15.0799 9.42139 15.0349 9.40139 15.0209 9.43239C15.0109 9.46439 15.0579 9.48338 15.0579 9.48338L17.4839 10.5964L17.5839 10.3504Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4857 10.5905L15.0536 9.49052C15.0346 9.48052 15.0026 9.45952 15.0126 9.42752C15.0286 9.39952 15.0676 9.40452 15.0826 9.41252L17.5866 10.3405L17.5826 10.3565L15.0786 9.42752C15.0746 9.42752 15.0376 9.41152 15.0276 9.43452C15.0196 9.45952 15.0566 9.47553 15.0566 9.47553L17.4857 10.5905Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5588 10.4125L15.8398 9.76953L17.5078 10.5355L17.5588 10.4125Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8341 9.91093C16.5841 9.63993 16.2791 9.65692 16.0661 9.40192C15.8551 9.14892 15.5971 9.14394 15.4741 9.08494C15.3551 9.02294 15.3631 8.90794 15.3221 8.92094C15.2831 8.93394 15.2931 9.06493 15.4451 9.17493C15.5891 9.28493 15.7281 9.22593 15.9901 9.53193C16.2541 9.84193 16.4571 9.76694 16.6851 10.0589L16.8341 9.91093Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6899 10.0555C16.5629 9.91751 16.4569 9.86551 16.3439 9.80951C16.2289 9.75051 16.1128 9.69252 15.9828 9.53852C15.8128 9.33852 15.6959 9.29551 15.5939 9.25751C15.5389 9.23951 15.4919 9.21951 15.4379 9.18251C15.3309 9.10051 15.2859 9.00351 15.2939 8.94951L15.3188 8.91652C15.3398 8.90652 15.3558 8.92851 15.3678 8.95551C15.3858 8.99051 15.4109 9.04451 15.4789 9.07851C15.5079 9.09451 15.5509 9.10552 15.5979 9.11852C15.7329 9.15752 15.9179 9.21051 16.0729 9.39951C16.1779 9.52451 16.3049 9.58252 16.4399 9.64452C16.5769 9.70552 16.7148 9.76951 16.8418 9.90651L16.8279 9.91852C16.7029 9.78452 16.5659 9.72051 16.4349 9.65851C16.2929 9.59551 16.1678 9.53651 16.0578 9.41051C15.9058 9.22451 15.7239 9.17351 15.5929 9.13651C15.5419 9.12151 15.5028 9.10952 15.4698 9.09452C15.3978 9.05652 15.3679 9.00051 15.3509 8.96451C15.3389 8.93851 15.3329 8.92551 15.3219 8.93051C15.3039 8.99451 15.3358 9.08651 15.4488 9.16951C15.4998 9.20551 15.5468 9.22351 15.5968 9.24251C15.7018 9.28051 15.8219 9.32352 15.9949 9.52852C16.1219 9.68152 16.2389 9.73852 16.3509 9.79552C16.4689 9.85152 16.5759 9.90651 16.6899 10.0555Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7395 9.91611C16.4755 9.68011 16.2225 9.7081 16.0205 9.4541C16.1395 9.6951 16.4265 9.6861 16.6885 9.9631L16.7395 9.91611Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4844 10.5966L19.9883 11.5256C19.9883 11.5256 20.0314 11.5456 20.0474 11.5136C20.0614 11.4826 20.0143 11.4646 20.0143 11.4646L17.5844 10.3506L17.4844 10.5966Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0175 11.5394C20.0035 11.5394 19.9964 11.5355 19.9844 11.5325L17.4805 10.6044L17.4865 10.5894L19.9924 11.5175C19.9924 11.5175 20.0274 11.5324 20.0394 11.5094C20.0514 11.4884 20.0104 11.4704 20.0104 11.4704L17.5825 10.3564L20.0184 11.4565C20.0364 11.4655 20.0695 11.4874 20.0555 11.5164C20.0465 11.5334 20.0305 11.5394 20.0175 11.5394Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5078 10.5351L19.2268 11.1741L17.5588 10.4121L17.5078 10.5351Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 11.0367C18.4884 11.3077 18.7934 11.2907 19.0024 11.5447C19.2154 11.7997 19.4734 11.8027 19.5944 11.8617C19.7174 11.9247 19.7054 12.0397 19.7504 12.0257C19.7854 12.0117 19.7734 11.8807 19.6254 11.7707C19.4774 11.6617 19.3443 11.7227 19.0823 11.4157C18.8163 11.1067 18.6114 11.1807 18.3874 10.8867L18.2344 11.0367Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7415 12.0356C19.7225 12.0356 19.7124 12.0146 19.7004 11.9916C19.6824 11.9566 19.6574 11.9036 19.5934 11.8696C19.5604 11.8526 19.5174 11.8416 19.4664 11.8266C19.3354 11.7896 19.1504 11.7366 18.9974 11.5496C18.8934 11.4246 18.7615 11.3646 18.6285 11.3046C18.4935 11.2416 18.3535 11.1776 18.2305 11.0436L18.2405 11.0316C18.3635 11.1656 18.5025 11.2266 18.6375 11.2896C18.7745 11.3516 18.9014 11.4096 19.0104 11.5376C19.1624 11.7236 19.3444 11.7736 19.4734 11.8116C19.5244 11.8266 19.5654 11.8376 19.5984 11.8546C19.6704 11.8906 19.7005 11.9476 19.7175 11.9836C19.7315 12.0136 19.7355 12.0196 19.7465 12.0166C19.7645 11.9556 19.7345 11.8616 19.6215 11.7776C19.5705 11.7426 19.5234 11.7236 19.4694 11.7066C19.3654 11.6686 19.2485 11.6246 19.0715 11.4206C18.9465 11.2686 18.8295 11.2096 18.7155 11.1536C18.6045 11.0946 18.4944 11.0406 18.3834 10.8906C18.5064 11.0276 18.6125 11.0796 18.7275 11.1386C18.8405 11.1946 18.9554 11.2536 19.0864 11.4096C19.2564 11.6096 19.3715 11.6516 19.4775 11.6906C19.5325 11.7096 19.5795 11.7256 19.6295 11.7656C19.7505 11.8526 19.7814 11.9536 19.7734 11.9986L19.7524 12.0326C19.7494 12.0346 19.7455 12.0356 19.7415 12.0356Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.332 11.0294C18.592 11.2674 18.8461 11.2354 19.0471 11.4944C18.9261 11.2524 18.6411 11.2584 18.3831 10.9844L18.332 11.0294Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4839 10.3506L15.0579 11.4646C15.0579 11.4646 15.0109 11.4826 15.0209 11.5136C15.0349 11.5456 15.0799 11.5256 15.0799 11.5256L17.5839 10.5966L17.4839 10.3506Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0546 11.5398C15.0386 11.5398 15.0216 11.5338 15.0136 11.5168C15.0036 11.4888 15.0356 11.4648 15.0546 11.4568L17.4807 10.3428L17.4866 10.3578L15.0587 11.4718C15.0587 11.4718 15.0217 11.4898 15.0297 11.5108C15.0397 11.5338 15.0766 11.5188 15.0806 11.5188L17.5847 10.5908L15.0847 11.5328C15.0757 11.5358 15.0646 11.5398 15.0546 11.5398Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5078 10.4121L15.8398 11.1741L17.5588 10.5351L17.5078 10.4121Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6428 10.5709C16.2738 10.5569 16.0708 10.7839 15.7388 10.7549C15.4108 10.7259 15.2248 10.9049 15.0978 10.9479C14.9668 10.9909 14.8908 10.9009 14.8728 10.9409C14.8518 10.9769 14.9568 11.0599 15.1368 11.0329C15.3188 11.0069 15.3768 10.8679 15.7758 10.8989C16.1778 10.9319 16.2738 10.7339 16.6428 10.7839V10.5709Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0683 11.0463C14.9603 11.0463 14.8943 11.0073 14.8733 10.9773L14.8633 10.9363C14.8773 10.9143 14.8983 10.9223 14.9273 10.9323C14.9643 10.9453 15.0213 10.9633 15.0893 10.9413C15.1263 10.9303 15.1653 10.9083 15.2103 10.8833C15.3333 10.8173 15.4953 10.7253 15.7373 10.7453C15.9013 10.7623 16.0363 10.7113 16.1733 10.6593C16.3123 10.6083 16.4523 10.5543 16.6423 10.5623V10.5793C16.4643 10.5713 16.3163 10.6253 16.1773 10.6743C16.0403 10.7273 15.9063 10.7753 15.7383 10.7623C15.5043 10.7413 15.3363 10.8303 15.2173 10.8993C15.1743 10.9223 15.1333 10.9423 15.0983 10.9563C15.0223 10.9793 14.9613 10.9623 14.9243 10.9483C14.8913 10.9363 14.8833 10.9363 14.8813 10.9423C14.9143 11.0033 14.9963 11.0463 15.1373 11.0243C15.1963 11.0153 15.2463 10.9943 15.2933 10.9713C15.3943 10.9233 15.5083 10.8703 15.7753 10.8913C15.9743 10.9093 16.0973 10.8683 16.2183 10.8283C16.3413 10.7883 16.4563 10.7503 16.6423 10.7743C16.4493 10.7643 16.3433 10.8043 16.2223 10.8433C16.1013 10.8833 15.9783 10.9223 15.7753 10.9073C15.5113 10.8863 15.3983 10.9403 15.3003 10.9853C15.2493 11.0083 15.2023 11.0313 15.1403 11.0423C15.1153 11.0433 15.0903 11.0463 15.0683 11.0463Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5802 10.6416C16.2252 10.6606 16.0702 10.8616 15.7422 10.8216C16.0002 10.9086 16.1952 10.7006 16.5762 10.7126L16.5802 10.6416Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5844 10.597L20.0143 9.48394C20.0143 9.48394 20.0614 9.46495 20.0474 9.43295C20.0314 9.40295 19.9883 9.42195 19.9883 9.42195L17.4844 10.3509L17.5844 10.597Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5883 10.6043L17.5823 10.5893L20.0103 9.47525C20.0103 9.47525 20.0513 9.45825 20.0393 9.43425C20.0273 9.41225 19.9923 9.42725 19.9923 9.42725L17.4863 10.3562L19.9843 9.41326C20.0043 9.40426 20.0433 9.39926 20.0543 9.42826C20.0683 9.45926 20.0353 9.48126 20.0173 9.49126L17.5883 10.6043Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5588 10.5355L19.2268 9.76953L17.5078 10.4125L17.5588 10.5355Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 10.3751C18.7947 10.3901 19.0017 10.1611 19.3317 10.1921C19.6617 10.2211 19.8477 10.0401 19.9727 9.99813C20.1037 9.95813 20.1797 10.0441 20.1997 10.0061C20.2177 9.97015 20.1157 9.88614 19.9297 9.91214C19.7497 9.94114 19.6957 10.0781 19.2927 10.0461C18.8907 10.0141 18.7947 10.2101 18.4297 10.1611V10.3751Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4607 10.3843C18.4507 10.3843 18.4417 10.3843 18.4297 10.3843V10.3673C18.6117 10.3733 18.7517 10.3223 18.8907 10.2703C19.0317 10.2173 19.1657 10.1693 19.3317 10.1843C19.5677 10.2053 19.7337 10.1153 19.8537 10.0473C19.8987 10.0223 19.9377 10.0013 19.9727 9.98927C20.0507 9.96427 20.1077 9.98426 20.1487 9.99826C20.1757 10.0093 20.1877 10.0113 20.1877 10.0023C20.1587 9.94427 20.0727 9.90027 19.9337 9.91927C19.8707 9.92927 19.8247 9.94927 19.7777 9.97427C19.6727 10.0223 19.5607 10.0753 19.2937 10.0533C19.0967 10.0363 18.9697 10.0773 18.8537 10.1173C18.7307 10.1563 18.6137 10.1933 18.4297 10.1703C18.6137 10.1793 18.7267 10.1403 18.8457 10.1003C18.9647 10.0623 19.0897 10.0223 19.2927 10.0373C19.5567 10.0583 19.6697 10.0063 19.7677 9.96127C19.8187 9.93627 19.8697 9.91227 19.9297 9.90427C20.0687 9.88327 20.1657 9.92227 20.1997 9.96927L20.2057 10.0103C20.1957 10.0313 20.1707 10.0243 20.1417 10.0143C20.1047 10.0013 20.0517 9.98226 19.9777 10.0053C19.9467 10.0173 19.9057 10.0363 19.8627 10.0623C19.7397 10.1313 19.5757 10.2213 19.3297 10.2003C19.1677 10.1843 19.0367 10.2353 18.8977 10.2873C18.7657 10.3353 18.6327 10.3843 18.4607 10.3843Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4922 10.3036C18.8462 10.2876 19.0022 10.0866 19.3242 10.1246C19.0702 10.0376 18.8712 10.2486 18.4942 10.2366L18.4922 10.3036Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6555 10.4216L16.5445 7.99461C16.5445 7.99461 16.5245 7.94861 16.4935 7.96261C16.4645 7.97561 16.4815 8.02061 16.4815 8.02061L17.4095 10.5256L17.6555 10.4216Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 10.5201L16.4764 8.02213C16.4764 8.02013 16.4645 7.99413 16.4725 7.97313L16.5155 7.95312C16.5405 7.96212 16.5505 7.99013 16.5505 7.99013L17.6635 10.4171L17.6495 10.4241L16.5145 7.96114L16.4945 7.96812L16.4885 8.01514L17.4175 10.5201Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.596 10.4473L16.834 8.78027L17.477 10.4983L17.596 10.4473Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4398 9.58064C17.4538 9.21064 17.2268 9.00765 17.2538 8.67865C17.2828 8.34865 17.1018 8.16164 17.0588 8.03364C17.0198 7.90464 17.1058 7.83065 17.0708 7.81065C17.0298 7.79265 16.9478 7.89365 16.9768 8.07565C17.0038 8.25965 17.1428 8.31165 17.1098 8.71565C17.0788 9.11865 17.2738 9.21165 17.2268 9.57965L17.4398 9.58064Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 9.58075H17.4288C17.4348 9.39775 17.3818 9.25676 17.3328 9.11876C17.2798 8.97676 17.2297 8.84575 17.2427 8.67775C17.2647 8.43875 17.1747 8.27675 17.1077 8.15675C17.0827 8.10975 17.0608 8.07076 17.0488 8.03876C17.0278 7.95976 17.0467 7.90076 17.0607 7.86176C17.0687 7.83376 17.0728 7.82276 17.0648 7.81876C17.0018 7.84976 16.9628 7.93676 16.9808 8.07376C16.9928 8.13476 17.0138 8.18176 17.0358 8.23276C17.0828 8.33476 17.1378 8.44775 17.1158 8.71475C17.0998 8.91375 17.1408 9.03675 17.1788 9.15475C17.2178 9.27775 17.2568 9.39175 17.2318 9.57875C17.2398 9.39375 17.2028 9.28076 17.1638 9.15976C17.1248 9.03976 17.0838 8.91576 17.0988 8.71376C17.1198 8.44976 17.0698 8.33775 17.0228 8.23875C16.9998 8.18775 16.9758 8.13976 16.9678 8.07776C16.9468 7.94076 16.9858 7.84376 17.0278 7.81076L17.0728 7.80176C17.0938 7.81276 17.0868 7.83675 17.0768 7.86575C17.0608 7.90275 17.0438 7.95875 17.0648 8.02975C17.0768 8.06375 17.0998 8.10176 17.1238 8.14676C17.1888 8.26676 17.2817 8.43376 17.2607 8.67676C17.2467 8.83976 17.2938 8.97176 17.3488 9.11176C17.3998 9.25176 17.4528 9.39475 17.4468 9.58075Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3669 9.51859C17.3489 9.16359 17.1499 9.00659 17.1849 8.68359C17.0989 8.93859 17.3079 9.13759 17.2979 9.51559L17.3669 9.51859Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4102 10.5249L18.5272 12.9529C18.5272 12.9529 18.5452 12.9989 18.5742 12.9849C18.6072 12.9729 18.5902 12.9269 18.5902 12.9269L17.6572 10.4209L17.4102 10.5249Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5784 12.9938C18.5314 12.9838 18.5154 12.9568 18.5154 12.9568L17.4023 10.5278L17.4184 10.5208L18.5353 12.9478C18.5353 12.9478 18.5523 12.9888 18.5743 12.9778C18.5953 12.9688 18.5784 12.9288 18.5784 12.9288L17.6504 10.4248L18.5953 12.9228C18.6043 12.9428 18.6114 12.9798 18.5784 12.9938Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4766 10.4983L18.2375 12.1663L17.5956 10.4473L17.4766 10.4983Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6326 11.3652C17.6166 11.7342 17.8457 11.9382 17.8167 12.2682C17.7877 12.5962 17.9686 12.7822 18.0076 12.9132C18.0526 13.0412 17.9607 13.1162 18.0017 13.1352C18.0387 13.1542 18.1207 13.0502 18.0957 12.8682C18.0667 12.6872 17.9296 12.6332 17.9606 12.2292C17.9936 11.8292 17.7987 11.7332 17.8457 11.3672L17.6326 11.3652Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9977 13.1442C17.9727 13.1322 17.9837 13.1062 17.9937 13.0812C18.0057 13.0432 18.0267 12.9872 18.0017 12.9152C17.9897 12.8802 17.9687 12.8422 17.9427 12.7962C17.8777 12.6762 17.7867 12.5102 17.8037 12.2672C17.8197 12.1042 17.7727 11.9742 17.7217 11.8342C17.6707 11.6942 17.6127 11.5512 17.6197 11.3652L17.6377 11.3662C17.6317 11.5492 17.6847 11.6912 17.7357 11.8282C17.7907 11.9682 17.8377 12.1012 17.8237 12.2682C17.8017 12.5042 17.8917 12.6692 17.9567 12.7892C17.9837 12.8342 18.0057 12.8732 18.0157 12.9092C18.0407 12.9862 18.0237 13.0442 18.0077 13.0852C17.9977 13.1122 17.9977 13.1222 18.0057 13.1282C18.0627 13.0962 18.1077 13.0092 18.0857 12.8692C18.0777 12.8092 18.0567 12.7632 18.0307 12.7122C17.9877 12.6112 17.9327 12.4982 17.9547 12.2302C17.9687 12.0312 17.9297 11.9102 17.8887 11.7902C17.8497 11.6682 17.8127 11.5532 17.8357 11.3662C17.8277 11.5512 17.8667 11.6652 17.9057 11.7852C17.9427 11.9052 17.9877 12.0302 17.9687 12.2312C17.9477 12.4952 18.0017 12.6082 18.0447 12.7072C18.0697 12.7582 18.0917 12.8062 18.1037 12.8692C18.1217 13.0052 18.0817 13.1002 18.0397 13.1362L17.9977 13.1442Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7031 11.4297C17.7231 11.7837 17.9221 11.9417 17.8831 12.2647C17.9691 12.0077 17.7621 11.8107 17.7741 11.4347L17.7031 11.4297Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5353 9.38672C18.1373 9.38672 18.6213 9.87173 18.6213 10.4717C18.6213 11.0747 18.1373 11.5607 17.5353 11.5607C16.9313 11.5607 16.4453 11.0747 16.4453 10.4717C16.4453 9.87173 16.9323 9.38672 17.5353 9.38672Z",
    fill: "#F1BD51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5344 11.569C16.9284 11.569 16.4385 11.0779 16.4385 10.4709C16.4385 9.86895 16.9284 9.37695 17.5344 9.37695C18.1374 9.37695 18.6324 9.86895 18.6324 10.4709C18.6324 11.0779 18.1384 11.569 17.5344 11.569ZM17.5344 9.39496C16.9384 9.39496 16.4525 9.87895 16.4525 10.472C16.4525 11.07 16.9384 11.554 17.5344 11.554C18.1324 11.554 18.6124 11.07 18.6124 10.472C18.6124 9.87895 18.1324 9.39496 17.5344 9.39496Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2232 10.2384C18.0282 10.0724 17.7872 10.0464 17.6512 10.1744C17.5552 10.3014 17.5632 10.4564 17.6802 10.6164C17.6682 10.6164 17.6512 10.6254 17.6432 10.6304C17.5592 10.4714 17.5452 10.3054 17.6002 10.1554C17.7872 10.0054 18.0392 9.98842 18.2232 10.2384Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9216 10.1885C17.8086 10.1885 17.7866 10.2145 17.7356 10.2555C17.6846 10.2985 17.6596 10.2885 17.6496 10.2985C17.6416 10.3055 17.6496 10.3315 17.6676 10.3225C17.6846 10.3125 17.7185 10.2985 17.7685 10.2555C17.8155 10.2145 17.8706 10.2145 17.9206 10.2145C18.0686 10.2145 18.1526 10.3395 18.1706 10.3315C18.1876 10.3225 18.0856 10.1885 17.9216 10.1885Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1088 10.3313C18.0058 10.2143 17.8018 10.2053 17.7178 10.3393H17.7507C17.8347 10.2053 18.0378 10.2623 18.0518 10.3223V10.3393L18.1088 10.3313Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9041 10.2461C17.9431 10.2461 17.9801 10.2811 17.9801 10.3221C17.9801 10.3631 17.9431 10.3971 17.9041 10.3971C17.8631 10.3971 17.8281 10.3631 17.8281 10.3221C17.8281 10.2811 17.8631 10.2461 17.9041 10.2461Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 10.3393C17.8027 10.4133 17.9877 10.4233 18.1097 10.3313L18.0527 10.3223C17.9687 10.4133 17.8358 10.4053 17.7518 10.3393V10.3223L17.7188 10.3393Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1207 10.3724C17.9797 10.4824 17.8357 10.4714 17.7517 10.4234C17.6677 10.3724 17.6677 10.3574 17.6847 10.3574C17.7007 10.3574 17.7177 10.3734 17.7867 10.4064C17.8537 10.4384 17.9547 10.4384 18.1207 10.3724Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7105 10.626C17.7355 10.633 17.7515 10.663 17.7395 10.689C17.7295 10.715 17.7005 10.73 17.6795 10.719C17.6565 10.713 17.6465 10.696 17.6425 10.675C17.6345 10.691 17.5995 10.741 17.5355 10.741H17.5195L17.5355 10.766C17.5525 10.766 17.5995 10.766 17.6355 10.741C17.6605 10.775 17.7035 10.784 17.7405 10.762C17.7735 10.737 17.7855 10.69 17.7585 10.655C17.7475 10.638 17.7305 10.628 17.7105 10.626Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8085 10.9746C17.7365 10.9246 17.7015 10.8496 17.6175 10.8496C17.5995 10.8496 17.5665 10.8586 17.5355 10.8756H17.5195L17.5355 10.8986C17.5665 10.8986 17.6175 10.8576 17.6795 10.8906C17.7355 10.9246 17.7685 10.9576 17.8085 10.9746Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7866 10.975C17.6166 10.925 17.5835 10.9579 17.5345 10.9579H17.5186L17.5345 10.9929C17.5995 10.9929 17.6346 10.942 17.7866 10.975Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8085 10.9744C17.6285 10.9574 17.6855 11.0674 17.5355 11.0674H17.5195L17.5355 11.0924C17.7185 11.0924 17.6345 10.9924 17.8085 10.9744Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6848 11.2418C17.6848 11.1598 17.6168 11.0928 17.5348 11.0928C17.4528 11.0928 17.3828 11.1598 17.3828 11.2418C17.4018 11.1598 17.4868 11.1078 17.5708 11.1298C17.6288 11.1428 17.6718 11.1858 17.6848 11.2418Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 10.2384C17.0407 10.0724 17.2827 10.0464 17.4177 10.1744C17.5157 10.3014 17.5036 10.4564 17.3926 10.6164C17.4006 10.6164 17.4177 10.6254 17.4257 10.6304C17.5077 10.4714 17.5276 10.3054 17.4686 10.1554C17.2826 10.0054 17.0327 9.98842 16.8477 10.2384Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1504 10.1885C17.2574 10.1885 17.2833 10.2145 17.3343 10.2555C17.3833 10.2985 17.4064 10.2885 17.4184 10.2985C17.4264 10.3055 17.4184 10.3315 17.4004 10.3225C17.3824 10.3125 17.3513 10.2985 17.2983 10.2555C17.2493 10.2145 17.1984 10.2145 17.1504 10.2145C17.0004 10.2145 16.9183 10.3395 16.8983 10.3315C16.8813 10.3225 16.9824 10.1885 17.1504 10.1885Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.957 10.3313C17.066 10.2143 17.2661 10.2053 17.3521 10.3393H17.3171C17.2331 10.2053 17.0341 10.2623 17.0201 10.3223V10.3393L16.957 10.3313Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1678 10.2461C17.1248 10.2461 17.0918 10.2811 17.0918 10.3221C17.0918 10.3631 17.1248 10.3971 17.1678 10.3971C17.2068 10.3971 17.2398 10.3631 17.2398 10.3221C17.2398 10.2811 17.2068 10.2461 17.1678 10.2461Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3521 10.3393C17.2661 10.4133 17.084 10.4233 16.957 10.3313L17.0201 10.3223C17.1001 10.4133 17.2331 10.4053 17.3171 10.3393V10.3223L17.3521 10.3393Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9473 10.3724C17.0913 10.4824 17.2322 10.4714 17.3162 10.4234C17.4002 10.3724 17.4003 10.3574 17.3823 10.3574C17.3663 10.3574 17.3512 10.3734 17.2822 10.4064C17.2152 10.4384 17.1173 10.4384 16.9473 10.3724Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3591 10.626C17.3341 10.633 17.32 10.663 17.332 10.689C17.338 10.715 17.3671 10.73 17.3931 10.719C17.4111 10.713 17.4261 10.696 17.4261 10.675C17.4341 10.691 17.469 10.741 17.535 10.741H17.5521L17.535 10.766C17.519 10.766 17.469 10.766 17.433 10.741C17.41 10.775 17.3631 10.784 17.3311 10.762C17.2941 10.737 17.286 10.69 17.308 10.655C17.324 10.638 17.3421 10.628 17.3591 10.626Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 10.9746C17.3338 10.9246 17.3668 10.8496 17.4508 10.8496C17.4688 10.8496 17.5018 10.8586 17.5348 10.8756H17.5518L17.5348 10.8986C17.5018 10.8986 17.4508 10.8576 17.3918 10.8906C17.3328 10.9236 17.2988 10.9576 17.2578 10.9746Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 10.975C17.4512 10.925 17.4842 10.9579 17.5352 10.9579H17.5522L17.5352 10.9929C17.4692 10.9929 17.4342 10.942 17.2832 10.975Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 10.9744C17.4438 10.9574 17.3828 11.0674 17.5348 11.0674H17.5518L17.5348 11.0924C17.3518 11.0924 17.4338 10.9924 17.2578 10.9744Z",
    fill: "#7A361D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_11472_85191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 0.685547H0.753906V20.2615H34.3149V0.685547Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_11472_85191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 11.2418C17.3828 11.1598 17.4528 11.0928 17.5348 11.0928C17.6168 11.0928 17.6848 11.1598 17.6848 11.2418C17.6678 11.1598 17.5828 11.1078 17.4968 11.1298C17.4428 11.1428 17.3958 11.1858 17.3828 11.2418Z",
    fill: "#7A361D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentina);
export default __webpack_public_path__ + "static/media/ARGENTINA.46657d34ff6d9f8cf2ab90dedd9fdfe3.svg";
export { ForwardRef as ReactComponent };